/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentStates } from './equipment-states';
import { SearchContainersSocketTypeResponse } from './search-containers-socket-type-response';
import { SearchContainersEquipmentResponse } from './search-containers-equipment-response';


export interface SearchContainersPlaceResponse { 
    id: string;
    number: number;
    subnet: string;
    equipmentState: EquipmentStates;
    equipment?: SearchContainersEquipmentResponse;
    socketType?: SearchContainersSocketTypeResponse;
}



